import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/auth';

const config = {
    apiKey: "AIzaSyBgQJT3josFk-km42SIJi2mdK7lE8hF-OY",
    authDomain: "vqpoints.firebaseapp.com",
    databaseURL: "https://vqpoints.firebaseio.com",
    projectId: "vqpoints",
    storageBucket: "vqpoints.appspot.com",
    messagingSenderId: "41601324137",
    appId: "1:41601324137:web:15b8abb61da11a85813ef8",
    measurementId: "G-8C1Q8ZFHJV"
}
export const createUserProfileDocument = async (userAuth,name,phone) => {
    if(!userAuth) return;
    const userRef = firestore.doc(`users/${userAuth.uid}`)
    const snapShot = await userRef.get();
    if(!snapShot.exists){
        const{email} = userAuth;
        const createdAt = new Date().toString();
        try {
            await userRef.set({
                id: Math.floor(Math.random() * 1000000000000000) + 1,
                name:name,
                email:email,
                joined: createdAt,
                entries:0,
                isBlocked:false,
                phone: phone,
                sentRequests: [],
                receivedRequests: []
            })
        } catch (error) {
            console.log('error creating user',error)
        }
    }
    return userRef;
     
}
firebase.initializeApp(config);
export const getCurrentUser = () =>{
    return new Promise((resolve,reject)=>{
        const unsubscribe = auth.onAuthStateChanged(userAuth => {
            unsubscribe();
            resolve(userAuth)
        },reject)
    })
}
export const auth = firebase.auth();
export const firestore = firebase.firestore();
export default firebase;
